export class AuthenticateRequestModel {
   public userName: string;
    public password: string;
}
